import { ClaudeTemplate } from "../types";

export const tiktokTemplate: ClaudeTemplate = {
  id: "tiktok",
  tool: "TikTok Ads Manager",
  url: "https://ads.tiktok.com/",
  hierarchy:
    "Business Center → Ad account (advertiser) → Campaign → Ad group → Ad",
  idHint:
    "columna ID del listado de campañas (puede que haya que activarla en Custom columns)",
  accountField: "tiktokAdvertiserIds",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre TikTok Ads Manager ({{url}}). Si ya está abierto, sigue.
2. Elige la **Ad account** de {{client}} (desde Business Center si hace falta). ID(s) conocidos: {{accountIds}}. Si no hay ID, búscala por nombre; si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, "Create" en modo manual (no Smart+, salvo que las notas lo pidan):
   - Advertising objective según {{goal.kpi}}: CPM → Reach; CPC → Traffic; CPV → Video views; CPE → Community interaction; CPL → Lead generation; CPA → Website conversions.
   - Campaign name: {{names.order}}
   - Campaign budget optimization: desactivado (el presupuesto va en el ad group).

### 3. Ad group
1. Ad group name: {{names.line}}
2. Placement: TikTok (desactiva Pangle y otros, salvo que las notas digan otra cosa).
3. Targeting:
   - Location: {{target.geography}} (país {{goal.country}}).
   - Gender: {{target.gender}}. Age: {{target.age}} (TikTok usa tramos fijos: elige los que cubran el rango). Language: {{target.language}}.
   - Interests & behaviors: {{target.interests}}.
   - Audiences (custom / lookalike): {{target.audience}}. Si no existen, no las crees: apúntalo.
   - Devices: {{target.technology}}.
   - Exclusiones: {{target.exclusions}}.
4. Budget & schedule: **Lifetime budget** {{goal.budget}}, del {{goal.startDate}} al {{goal.endDate}}.
5. Bidding: por defecto (Maximum delivery). Si las notas piden coste controlado, cost cap en torno a {{goal.netUnitCost}}.

### 4. Ad
1. Ad name: {{names.line}} (sufijo _01, _02… si hay varias piezas).
2. Identity: la cuenta de TikTok de {{brand}} / {{client}}. Si el briefing es SOCIAL_POSTS, usa "Spark Ads" con el post indicado; si no se indica, pregunta.
3. Vídeos: los del bloque "Creatividades". Texto y CTA: bloque "Copies".
4. Destination URL: bloque "URLs de destino" (con UTM).
5. Deja la campaña **desactivada** al terminar; no pulses "Publish" sin mi confirmación (si la herramienta obliga a publicar para guardar, avísame antes).
`,
};
